export default __webpack_public_path__ + "static/media/useful.3bde4a0c.png";